import { useLocation, useNavigate } from "react-router-dom";
import { lanternData } from "../../utils";
import BackBtn from "../../compoment/icon/BackBtn";

const ColorSelectionScreen = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const { ticketData } = location.state || {}

    const handleNext = (item: any) => {
        localStorage.setItem("color", item?.btnLabel)
        navigate("/selected-lantern", { state: { selectedLantern: item, ticketData: ticketData } });
    };

    return (
        <>
            <section className="colorSection">
                <div className="mainContainerSection position-relative">
                    <div className="d-flex align-items-center justify-content-center ">
                        <button className="backBTN" onClick={() => navigate('/main')}>
                            <span className="me-2"><BackBtn /></span> Back</button>
                        <div className="heading ms-5">Tap to pick a color for your lantern</div>
                    </div>
                    <div className="lanternContainer">
                        {lanternData.map((item, index) => {
                            return (
                                <div key={index} className="singleLantern" onClick={() => handleNext(item)}>
                                    <div><img src={item.imgURL} alt="" /></div>
                                    <button className="lanternBtn" style={{ backgroundColor: item.btnBGColor, color: item.btnTxtColor }}>{item.btnLabel}</button>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>
        </>
    );
};

export default ColorSelectionScreen;
